import {post} from "../server/axios";
import {BASE_IDS_URL} from "../server/baseModelUrl";
const baseUrl = window.webConfig.baseApiPath;

export const getDepList  = (json)=>{
    const url = `${baseUrl}/shwsgs/getDepList`;
    return post(url,json)
};

// export const getCaseInfoList  = (json)=>{
//     const url = `${baseUrl}/shwsgs/getCaseInfoList`;
//     return post(url,json)
// };
// export const getCaseInfoDetail  = (id)=>{
//     const url = `${baseUrl}/shwsgs/getCaseInfoDetail/${id}`;
//     return post(url)
// };

// 获取公示案件列表
export const getCaseInfoList  = (json)=>{
    const url = baseUrl+ '/xzcfgs/getCaseInfoList';
    return post(url,json)
};
export const getCaseInfoDetail  = (id)=>{
    const url = `${baseUrl}/xzcfgs/getCaseInfoDetail/${id} `;
    return post(url)
};
